// Materialize off-screen gallery images only as their slide approaches view.
// Each Swiper clone gets its own lifecycle; native no-JS markup remains available.
class KPDeferredProductImage extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('template')) return;
    if (this.hasAttribute('data-desktop-only')) {
      this.desktopQuery = matchMedia('(min-width: 768px)');
      this.onDesktop = () => { if (this.desktopQuery.matches) this.load(); };
      if (this.desktopQuery.matches) return this.load();
      this.desktopQuery.addEventListener('change', this.onDesktop);
      return;
    }
    if (!('IntersectionObserver' in window)) return this.load();
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.load();
    }, { rootMargin: '150px' });
    this.observer.observe(this);
  }
  load() {
    const template = this.querySelector('template');
    if (!template) return;
    this.observer?.disconnect();
    this.desktopQuery?.removeEventListener('change', this.onDesktop);
    this.replaceChildren(template.content.cloneNode(true));
  }
  disconnectedCallback() { this.observer?.disconnect(); this.desktopQuery?.removeEventListener('change', this.onDesktop); }
}
customElements.define('kp-deferred-product-image', KPDeferredProductImage);
